import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./PremiumSlider.css";
import { Button } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import { API_URL } from "../utils/url";

const PremiumSlider = () => {
  const [[page, direction], setPage] = useState([0, 0]);
  const [videosData, setVideosData] = useState([]);
  const [loading, setLoading] = useState(false);

  // 5 Seconds automatic banner transition slider trigger active link
  useEffect(() => {
    const timer = setInterval(() => {
      paginate(1);
    }, 5000);
    return () => clearInterval(timer);
  }, [page]);

  const paginate = (newDirection) => {
    setPage([page + newDirection, newDirection]);
  };

  const handleNavigation = (youtubeId) => {
    const videoUrl = `https://www.youtube.com/watch?v=${youtubeId}`;
    window.open(videoUrl, "_blank", "noopener,noreferrer");
  };

  const fetchYoutube = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`${API_URL}/api/youtube/latest-youtube`);
      console.log(data, "jnono");
      setVideosData(data || []);
    } catch (error) {
      console.log(error);
      // toast.error("Unable to fetch videos.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchYoutube();
  }, []);
  const slideIndex = Math.abs(page % videosData?.length);

  const currentSlide = videosData[slideIndex] || {
    title: "Loading...",
    description: "Loading...",
    videoUrl: "",
  };
  const currentCanonicalUrl = window.location.origin + window.location.pathname;
  const slideVariants = {
    enter: (direction) => ({
      x: direction > 0 ? "100%" : "-100%",
      opacity: 0,
      scale: 1.02,
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1],
      },
    },
    exit: (direction) => ({
      zIndex: 0,
      x: direction < 0 ? "100%" : "-100%",
      opacity: 0,
      scale: 0.98,
      transition: {
        duration: 0.8,
      },
    }),
  };
  const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: (delay) => ({
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        delay: delay,
        ease: [0.16, 1, 0.3, 1],
      },
    }),
  };
  return (
    <>
      <Helmet>
        <title>
          Vishnu Ji Maharaj | Official Website | Bhakti Katha & Spiritual Wisdom
        </title>

        <meta
          name="description"
          content="Official Vishnu Ji Maharaj website featuring bhakti katha, spiritual teachings, Sanatan Dharma knowledge, devotional stories, and spiritual wisdom."
        />

        <meta
          name="keywords"
          content="Vishnu Ji Maharaj, Bhakti Katha, Sanatan Dharma, Spiritual Stories, Hindu Dharma, Krishna Katha, Jagannath Katha, Devotional Content"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Vishnu Ji Maharaj" />

        <link rel="canonical" href={currentCanonicalUrl} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Vishnu Ji Maharaj | Official Website"
        />
        <meta
          property="og:description"
          content="Explore bhakti katha, spiritual stories, Sanatan Dharma teachings, and devotional wisdom."
        />
        <meta property="og:url" content="https://vishnujimaharaj.com/" />
        <meta
          property="og:image"
          content="https://vishnujimaharaj.com/logo.png"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Vishnu Ji Maharaj | Official Website"
        />
        <meta
          name="twitter:description"
          content="Explore bhakti katha, spiritual stories, and Sanatan Dharma teachings."
        />
        <meta
          name="twitter:image"
          content="https://vishnujimaharaj.com/logo.png"
        />

        {/* Organization Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Vishnu Ji Maharaj",
            url: "https://vishnujimaharaj.com",
            logo: "https://vishnujimaharaj.com/logo.png",
          })}
        </script>

        {/* Website Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "Vishnu Ji Maharaj",
            url: "https://vishnujimaharaj.com",
          })}
        </script>
      </Helmet>
      <section
        className="premium-slider-section position-relative overflow-hidden"
        style={{ height: window.innerWidth < 768 ? "45vh" : "85vh" }}
      >
        <AnimatePresence initial={false} custom={direction} mode="wait">
          <motion.div
            key={page}
            custom={direction}
            variants={slideVariants}
            initial="enter"
            animate="center"
            exit="exit"
            className="slide-container position-absolute w-100 h-100"
            style={{ cursor: "pointer" }}
            onClick={() => handleNavigation(currentSlide.videoUrl)}
          >
            {/* Main Full-Screen YouTube Banner Wrapper Image Layer */}
            <div className="slide-image-wrapper w-100 h-100 position-relative">
              <img
                src={`https://img.youtube.com/vi/${currentSlide.videoUrl}/maxresdefault.jpg`}
                alt={currentSlide.title}
                className="premium-banner-img w-100 h-100"
                loading="eager"
                onError={(e) => {
                  // Agar Maxres HD image na mile to automatic high-quality fallback image apply hogi
                  e.target.onerror = null;
                  e.target.src = `https://img.youtube.com/vi/${currentSlide.videoUrl}/hqdefault.jpg`;
                }}
              />
              <h1>Vishnu Ji Maharaj</h1>
              {/* Subtle Gradient Mask Layer for Cinematic Contrast Look */}
              <div className="slide-clean-overlay position-absolute w-100 h-100" />
            </div>
          </motion.div>
        </AnimatePresence>

        {/* Premium Controls Arrows and Dots Indicators */}
        {videosData.length > 1 && (
          <div className="slider-controls position-absolute bottom-0 start-50 translate-middle-x z-3 d-flex align-items-center gap-3 py-4">
            <button
              className="control-btn prev"
              onClick={(e) => {
                e.stopPropagation();
                paginate(-1);
              }}
            >
              <FaChevronLeft size={14} />
            </button>

            <div
              className="slide-indicator d-flex gap-2"
              onClick={(e) => e.stopPropagation()}
            >
              {videosData.map((_, index) => (
                <div
                  key={index}
                  className={`dot ${index === slideIndex ? "active" : ""}`}
                  onClick={() => setPage([index, index > slideIndex ? 1 : -1])}
                  style={{ cursor: "pointer" }}
                />
              ))}
            </div>

            <button
              className="control-btn next"
              onClick={(e) => {
                e.stopPropagation();
                paginate(1);
              }}
            >
              <FaChevronRight size={14} />
            </button>
          </div>
        )}
      </section>
    </>
  );
};

export default PremiumSlider;
